import { createFileRoute, redirect, Outlet } from '@tanstack/react-router'
import { DashboardLayout } from '../components/layout/DashboardLayout'
import { useAuth } from '../contexts/AuthContext'
import { 
  ChartBarIcon, 
  UsersIcon, 
  CalendarIcon,
  CheckCircleIcon
} from '@heroicons/react/24/outline'

export const Route = createFileRoute('/dashboard')({
  beforeLoad: async () => {
    const token = localStorage.getItem('authToken')
    if (!token) {
      throw redirect({
        to: '/login',
        search: {
          redirect: '/dashboard',
        },
      })
    }
  },
  component: DashboardComponent,
})

function DashboardComponent() {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  )
}
